import React from "react";
import { Marker } from '@react-google-maps/api';
import Pin from "../Pin";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useMonitoringPin } from "../../../../hooks/useMonitoringPin";
import { SetDriverPopUp, SetOrderPinPopUp, SetOrderPinPopUpPosition, SetSelectedMonitoringDriver, SetSelectedMonitoringOrder, Table_ClearSelectedOrders, Table_DeSelectOrder, Table_SelectOrder } from "../../../../Redux/actions/actionNames";
import { GetColorByStatus } from "../../../../utils/get-colors-by-status";
import { getOrderMonitoringBounding } from "../../map-dropoff-pin/getOrderMonitoring";
import { isPickupDelivery } from "../../side-bar/components/orderTypes";



const App = ({ position, id ,  order , key , selected}) => {
  console.log("fewfccfewf ",position, id ,  order , key)
  const dispatch = useDispatch();
  let {orderIsSelected} = useMonitoringPin(order.id, order.driverId ,id)

  function OrderOnclick(event) {

 
    if (event.metaKey || event.ctrlKey || event.originalEvent?.metaKey || event.originalEvent?.ctrlKey || event.domEvent?.metaKey || event.domEvent?.ctrlKey) {
      if (selected) {
        dispatch(Table_DeSelectOrder(order.id))
      } else {
        dispatch(Table_SelectOrder(order))

      }

    } else {

    dispatch(Table_ClearSelectedOrders())

    dispatch(Table_SelectOrder(order))

    dispatch(SetSelectedMonitoringOrder(order.id))
    //  dispatch(SetDriverPopUp(null))
    dispatch(SetOrderPinPopUp(order))
    dispatch(SetOrderPinPopUpPosition({position:position , tag:"Pickup",orderId:order.id , customerId:order.customerId}))

 

    }
    
 
  }
  

  return  <Marker
        position={position}
        key={key}
        icon= {{
          anchor: selected ? { x: 14, y: 39 } : { x: 10, y: 34 },
          url: 'data:image/svg+xml;charset=utf-8,' +
          encodeURIComponent(ReactDOMServer.renderToStaticMarkup(<Pin selected={selected} /* style={!orderIsSelected && { opacity: ".2" }} */ color={"#"+GetColorByStatus(order.status , order)}/>))
        }}
        onClick={OrderOnclick}

        ></Marker> 
       

};

export default App

